"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeListStyleShorthand = exports.openListStyleShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
// list-style
var openListStyleShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'list-style',
        singleKeywordPart: { prop: 'list-style', dataType: css_data_types_1.listStyleSingleValueDataType },
        parts: [
            { prop: 'list-style-type', dataType: css_data_types_1.listStyleTypeDataType },
            { prop: 'list-style-image', dataType: css_data_types_1.imageSourceDataType },
            { prop: 'list-style-position', dataType: css_data_types_1.listStylePositionDataType },
        ],
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openListStyleShorthand = openListStyleShorthand;
var closeListStyleShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " ", " ", ""], ["", " ", " ", ""])), 'list-style-type', 'list-style-image', 'list-style-position'));
};
exports.closeListStyleShorthand = closeListStyleShorthand;
var templateObject_1;
//# sourceMappingURL=list-style-shorthand.js.map